import { render, staticRenderFns } from "./volume-delete.vue?vue&type=template&id=0a64aa54&scoped=true&"
import script from "./volume-delete.vue?vue&type=script&lang=js&"
export * from "./volume-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64aa54",
  null
  
)

export default component.exports